'use client';

import { MagnifyingGlassIcon, XIcon } from '@phosphor-icons/react';

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  /** Accessible name — override when the field searches something other than transactions. */
  ariaLabel?: string;
}

export function SearchBar({
  value,
  onChange,
  placeholder = 'Buscar por comércio ou categoria',
  disabled = false,
  ariaLabel = 'Buscar transações',
}: Props) {
  return (
    <div className="flex h-11 items-center gap-2 rounded-[var(--radius-2xl)] border border-border bg-surface px-4 shadow-[var(--shadow-1)]">
      <MagnifyingGlassIcon className="size-4 shrink-0 text-text-tertiary" weight="regular" />
      <input
        type="text"
        aria-label={ariaLabel}
        inputMode="search"
        enterKeyHint="search"
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className="min-w-0 flex-1 bg-transparent text-base outline-none placeholder:text-text-tertiary disabled:cursor-not-allowed disabled:opacity-60"
      />
      {value.length > 0 && !disabled && (
        <button
          type="button"
          aria-label="Limpar busca"
          onClick={() => onChange('')}
          className="text-text-secondary hover:text-text-primary"
        >
          <XIcon className="size-4" weight="bold" />
        </button>
      )}
    </div>
  );
}
